import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Kids Club Early Learning Center LLC</h3>
            <p>608 N Alexander St</p>
            <p>Plant City, FL 33563</p>
            <p>Phone: 813-752-6446</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/about">About Us</a></li>
              <li><a href="/curriculum">Curriculum</a></li>
              <li><a href="/schedule-tour">Schedule Tour</a></li>
              <li><a href="/contact-us">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="/forms">Forms</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/resources">Resources</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Kids Club Early Learning Center LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;